var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-location"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    clipPath: "url(#clip-location)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37318",
    "data-name": "Path 37318",
    d: "M8.149,11.837a3.464,3.464,0,0,0,3.47-3.47,3.571,3.571,0,0,0-3.47-3.594,3.464,3.464,0,0,0-3.47,3.47A3.658,3.658,0,0,0,8.149,11.837ZM2.324,2.417A8.238,8.238,0,0,1,13.975,14.068L8.149,19.893,2.324,14.068A8.463,8.463,0,0,1,2.324,2.417Z",
    transform: "matrix(1, 0.017, -0.017, 1, 1.979, 0)",
    fill: "#cadae3",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.9315c42c7e9757007bad7281715da597.svg";
export { ForwardRef as ReactComponent };